import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("label", {
  class: "ml-2.5 font-semibold",
  for: "taxPayer"
}, "Wajib Pajak Menggunakan KTP", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "w-1/2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_lp_input = _resolveComponent("lp-input")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_Title, { label: "Informasi Pajak" }),
    _createVNode(_component_DataWrapper, { class: "w-1/2" }, {
      default: _withCtx(() => [
        _createVNode("div", {
          class: `p-field-checkbox ml-2 ${_ctx.styleWrapper}`
        }, [
          _createVNode(_component_Checkbox, {
            id: "taxPayer",
            modelValue: _ctx.form.isTaxPayer,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.isTaxPayer = $event)),
            onChange: _ctx.onChangeCheckbox,
            binary: true
          }, null, 8, ["modelValue", "onChange"]),
          _hoisted_2
        ], 2)
      ]),
      _: 1
    }),
    (_ctx.form.isTaxPayer)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("div", {
            class: `flex justify-between gap-x-8 ${_ctx.styleWrapper}`
          }, [
            _createVNode(_component_DataWrapper, {
              label: "No. NIK",
              class: "w-1/2",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  format: _ctx.formatNumber,
                  onChange: _ctx.validateNIK,
                  error: _ctx.error.NIKNumber,
                  errorCaption: "Masukan No. NIK dengan benar",
                  modelValue: _ctx.form.NIK,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.NIK = $event)),
                  placeholder: "Masukan No. NIK",
                  maxLength: "16",
                  "show-max-length": ""
                }, null, 8, ["format", "onChange", "error", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              label: "Nama NIK",
              class: "w-1/2",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.form.NIKName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.NIKName = $event)),
                  placeholder: "Masukan nama NIK"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ], 2),
          _createVNode(_component_DataWrapper, {
            label: "Alamat NIK",
            class: _ctx.styleWrapper,
            asterisk: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                type: "textarea",
                modelValue: _ctx.form.NIKAddress,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.NIKAddress = $event)),
                placeholder: "Masukan alamat NIK"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["class"])
        ], 64))
      : _createCommentVNode("", true),
    _createVNode("div", {
      class: `flex justify-between gap-x-8 ${_ctx.styleWrapper}`
    }, [
      _createVNode(_component_DataWrapper, {
        label: "No. Registrasi Pajak (NPWP)",
        class: "w-1/2",
        asterisk: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_lp_input, {
            format: _ctx.formatted,
            onChange: _ctx.validateTaxNumber,
            error: _ctx.error.taxNumber,
            errorCaption: "Masukan No. Registrasi Pajak (NPWP) dengan benar",
            modelValue: _ctx.form.taxNumber,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.taxNumber = $event)),
            placeholder: "00.000.000.0-000.000",
            maxLength: "20",
            "show-max-length": ""
          }, null, 8, ["format", "onChange", "error", "modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_DataWrapper, {
        label: "Nama Wajib Pajak",
        class: "w-1/2",
        asterisk: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_lp_input, {
            modelValue: _ctx.form.NIKName,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.NIKName = $event)),
            placeholder: "Masukan nama wajib pajak",
            disabled: _ctx.form.isTaxPayer
          }, null, 8, ["modelValue", "disabled"])
        ]),
        _: 1
      })
    ], 2),
    _createVNode(_component_DataWrapper, {
      label: "Alamat Wajib Pajak",
      class: _ctx.styleWrapper,
      asterisk: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_lp_input, {
          type: "textarea",
          modelValue: _ctx.form.NIKAddress,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.NIKAddress = $event)),
          placeholder: "Masukan alamat wajib pajak",
          disabled: _ctx.form.isTaxPayer
        }, null, 8, ["modelValue", "disabled"])
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode("div", {
      class: `flex justify-between gap-x-8 ${_ctx.styleWrapper}`
    }, [
      _createVNode(_component_DataWrapper, {
        label: "Kode Transaksi",
        class: "w-1/2",
        asterisk: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_lp_input, {
            modelValue: _ctx.form.transactionCode,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.transactionCode = $event)),
            placeholder: "Masukan kode transaksi",
            disabled: ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _hoisted_3
    ], 2)
  ], 64))
}